// 国际版协议页旧页面
// 前端重定向到 zeta-privacy 页面上

import { isDev } from "@/utils/shared"

const { protocol, host, search = "?" } = window.location

if (isDev) {
  window.location.href = `${protocol}//${host}/zeta-privacy.html${search}&from=redirect`
} else {
  window.location.href = `${protocol}//${host}/h5/aries-web-static/zeta-privacy.html${search}&from=redirect`
}
